import { Job } from "./src/app/models";

/*
 ****************************************************************************
 *      THIS FILE WAS AUTOMATICALLY GENERATED. DO NOT UPDATE IT THERE!      *
 ****************************************************************************
 */

export const JOB_OFFERS: Job[] = [
  {
    id: "net-cloud-engineer-aws-specialist",
    title: ".NET Cloud Engineer (AWS Specialist)",
    salary: "16000-20000 PLN/netto",
    condition: "B2B long-term contract",
    description:
      "<p><strong>NiceProject</strong> is a group of specialists who focus on quality over quantity. Dedicated to the craft of product building. Our clients are leaders in their industries; they all perceive technology as a key ingredient to the success of their companies. We serve the manufacturing and printing industry in the field of IT solutions. Each of us has the opportunity to pursue our passion and interests individually and through project work. Nice Project culture supports talents by providing space for professional self-fulfillment.</p>\n<p>We are looking for an experienced Backend Developer (C# / .NET) to join a long-term, stable project for a global leader in the printing industry.</p>\n<p>You will work on a modern, cloud-based Inventory Management Application that automates consumable supply for print shops worldwide. The system ensures complete stock traceability, seamless integration between logistics and customer operations, mobile scanning of consumption, delivery validation, target-actual comparisons and powerful analytics for consumption optimization. </div></p>\n",
    responsibilities: [
      "Designing & developing backend services and business logic in C# / .NET",
      "Building and maintaining RESTful APIs",
      "Working with AWS services: RDS (PostgreSQL/MySQL), Fargate, Lambda, S3 and more",
      "Containerizing applications with Docker / Podman",
      "Infrastructure as Code with Terraform (or AWS CDK – nice to have)",
      "Close collaboration in a small, autonomous team: frontend devs, PO, German stakeholders",
      "Taking ownership of technical decisions and solution architecture",
      "Direct communication in English with client representatives (German is a plus)",
    ],
    requirements: [
      "5+ years of commercial backend development in C# / .NET",
      "Hands-on experience with AWS cloud services (at least 2–3 years)",
      "Solid knowledge of relational databases (design + optimization + querying)",
      "Practical experience with Docker or Podman",
      "Working knowledge of Terraform",
      "Very good spoken & written English",
      "Independent, self-organizing engineer who can quickly onboard and take ownership",
      "Strong decision-making skills",
      "Open-minded approach and good communication in a small remote team",
      "Comfortable working directly with international (German) stakeholders",
    ],
    niceToHave: [
      "AWS CDK experience",
      "Basic knowledge of TypeScript + Angular",
      "German language skills (B1+)",
      "Previous work on production-grade, scalable cloud systems",
      "Experience in supply-chain, inventory, logistics or manufacturing domains",
    ],
    whatWeOffer: [
      "B2B long-term contract",
      "Full paid leave (26 days)",
      "Development budget for trainings",
      "Private medical care",
      "Multisport card",
      "German lessons",
      "Office in Wrocław",
      "Strong team spirit and partnership culture",
    ],
    tags: [],
    detailsContract: "B2B, Long term contract, Full time",
    localization: "Wrocław (hybrid)",
  },
];
